module.exports = __webpack_public_path__ + "AM.png?4ea6eb562c76a3a5d51a99793922fc44";